import { useTranslation } from "react-i18next"

const I18N_BASE = "replenishments.show_replenishment_boxes.supplier_invoice"

// The piece-count table shows one row per lot, so each row keeps only its own
// lot's factura buckets (backend stamps every bucket with lot_id; null is the
// no-lot bucket). Loose equality on purpose: null lot rows match null lot_id.
export const invoiceQuantitiesForLot = (product, lotId) =>
  (product.invoice_quantities || []).filter(bucket => bucket.lot_id == lotId)

// Renders a received row's facturas as compact chips, amber for the no-factura
// bucket. Two input shapes (CUBBO-2134):
//   - invoiceQuantities [{ invoice_number, quantity }] → segmented pill "F-505 | ×6"
//     (piece-count flow, replenishments_paginated).
//   - invoiceNumbers [string|null] → plain number chip, no count
//     (box-scan flow, where the endpoint exposes numbers only).
// Renders nothing when empty so flag-off warehouses and un-received rows stay clean.
export const InvoiceQuantityChips = ({ invoiceQuantities, invoiceNumbers }) => {
  const { i18n } = useTranslation()

  const rows = (invoiceQuantities && invoiceQuantities.length)
    ? invoiceQuantities
    : (invoiceNumbers || []).map((invoice_number) => ({ invoice_number, quantity: null }))

  if (rows.length === 0) return null

  return (
    <div className="flex flex-col items-center gap-1">
      {rows.map(({ invoice_number, quantity }, index) => {
        const hasInvoice = Boolean(invoice_number)
        const label = hasInvoice ? invoice_number : i18n.t(`${I18N_BASE}.chip_empty`)
        const showQuantity = quantity != null
        const borderTone = hasInvoice ? "border-emerald-200" : "border-amber-300"
        const numberTone = hasInvoice ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"
        const quantityTone = hasInvoice
          ? "bg-emerald-100 text-emerald-800 border-emerald-200"
          : "bg-amber-100 text-amber-800 border-amber-300"
        return (
          <span
            key={`${invoice_number ?? "__none__"}-${index}`}
            title={showQuantity ? `${label} ×${quantity}` : label}
            className={`inline-flex w-32 overflow-hidden rounded-full border text-xs font-mono font-semibold ${borderTone}`}
          >
            <span className={`flex-1 truncate text-center px-2 py-0.5 ${numberTone}`}>{label}</span>
            {showQuantity &&
              <span className={`w-9 flex-shrink-0 text-center py-0.5 border-l ${quantityTone}`}>×{quantity}</span>
            }
          </span>
        )
      })}
    </div>
  )
}
